import api from './api';

export default {
  getAdverts() {
    return new Promise((resolve, reject) => {
      api
        .get('advert')
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  createAdvert({ name, image_url, url }) {
    return new Promise((resolve, reject) => {
      api
        .post('advert', { name, image_url, url })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  updateAdvert({ id, name, image_url, url, enabled }) {
    return new Promise((resolve, reject) => {
      api
        .put(`advert/${id}`, { updates: { name, image_url, url, enabled } })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getExclusions(id) {
    return new Promise((resolve, reject) => {
      api
        .get(`advert/${id}/excluded-partners`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  excludePartner(advertId, partnerId) {
    return new Promise((resolve, reject) => {
      api
        .post(`advert/${advertId}/exclude/${partnerId}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  includePartner(advertId, partnerId) {
    return new Promise((resolve, reject) => {
      api
        .post(`advert/${advertId}/include/${partnerId}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
